<div>
    <div class="progress-title">
        <span>Your Security Key is being Deleted...</span>
    </div>
    <div>
        <div>
            <mat-progress-bar mode="buffer" value="{{progress}}"></mat-progress-bar>
        </div>
    </div>
    <div class="mt-1">
        <span class="progress-info">You can access your forms and uploads again, once your key is deleted</span>
    </div>
</div>